import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
  TableBodySkeleton,
} from '../../../common';
import InternalOrderStatusChip from './InternalOrderStatusChip';

const InternalOrdersDataTable = ({
  data,
  isLoading,
  actionsDisabled = false,
  onView,
  LoadingComponent = TableBodySkeleton,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <TableBodySkeleton variant="box" />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((order, index) => (
              <Box
                key={order.uuid || index}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                  Pedido #{order.number}
                </Typography>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Depósito
                  </Typography>
                  <Typography variant="body2">
                    {order.warehouse_label || 'Sin depósito'}
                  </Typography>
                </Box>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Proyecto
                  </Typography>
                  <Typography variant="body2">
                    {order.project_label || 'Sin proyecto'}
                  </Typography>
                </Box>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Necesidad
                  </Typography>
                  <Typography variant="body2">
                    {order.requested_at_label || '-'}
                  </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    Estado
                  </Typography>
                  <Box sx={{ mt: 0.5 }}>
                    <InternalOrderStatusChip
                      status={order.status}
                      label={order.status_label}
                    />
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onView(order)}
                    disabled={actionsDisabled}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron pedidos técnicos" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="internal orders table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="10%" wxs="15%">
              Número
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Necesidad
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="20%">
              Depósito
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="20%">
              Proyecto
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Estado
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="15%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((order, index) => (
              <TableRow key={order.uuid || index}>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.number}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.requested_at_label || '-'}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.warehouse_label || 'Sin depósito'}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.project_label || 'Sin proyecto'}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  <InternalOrderStatusChip
                    status={order.status}
                    label={order.status_label}
                  />
                </RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onView(order)}
                    disabled={actionsDisabled}
                  />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={6} message="No se encontraron pedidos técnicos" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default InternalOrdersDataTable;
